  export const formStyles = {};
  export const formRowStyles = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' };
  export const formGroupStyles = { marginBottom: '1.5rem' };
  export const labelStyles = { display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#333' };
  export const inputStyles = { width: '100%', padding: '0.8rem', border: '2px solid #e9ecef', borderRadius: '8px', fontSize: '1rem', transition: 'border-color 0.3s ease' };
  export const textareaStyles = { width: '100%', padding: '0.8rem', border: '2px solid #e9ecef', borderRadius: '8px', fontSize: '1rem', resize: 'vertical', fontFamily: 'inherit' };
  export const primaryButtonStyles = {
    backgroundColor: '#006C35',
    color: 'white',
    border: 'none',
    padding: '1rem 2rem',
    borderRadius: '50px',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
};
export const containerStyles = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 2rem',
    width: '100%'
};
export const formDisclaimerStyles = {
    fontSize: '0.9rem',
    color: '#666',
    fontStyle: 'italic',
    marginTop: '1rem',
    textAlign: 'center'
};
export  const secondaryButtonStyles = {
    // backgroundColor: 'transparent',
    color: 'white',
    border: '2px solid white',
    padding: '1rem 2rem',
    borderRadius: '50px',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
  };
export const sectionStyles = { padding: '5rem 0' };
export const pageHeaderStyles = { backgroundColor: '#006C35', color: 'white', padding: '8rem 0 4rem 0', textAlign: 'center' };
export const pageHeaderTitleStyles = { fontSize: '3rem', fontWeight: '700', marginBottom: '1rem' };
export const pageHeaderSubStyles = { fontSize: '1.2rem', opacity: '0.9', maxWidth: '600px', margin: '0 auto' };
export const sectionTitleStyles = { fontSize: '2.5rem', fontWeight: '700', textAlign: 'center', marginBottom: '3rem', color: '#333' };
export const loadingStyles = { textAlign: 'center', padding: '2rem', fontSize: '1.1rem', color: '#666' };
export const readMoreButtonStyles = { backgroundColor: 'transparent', color: '#006C35', border: '2px solid #006C35', padding: '0.5rem 1.5rem', borderRadius: '25px', fontSize: '0.9rem', fontWeight: '600', cursor: 'pointer', transition: 'all 0.3s ease', marginTop: '1rem' };

export const aboutGridStyles = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center' };
export const aboutTextStyles = {};
export const aboutDescStyles = { fontSize: '1.1rem', lineHeight: '1.7', marginBottom: '1.5rem', color: '#666' };
export const aboutImageStyles = {};

export const valuesGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' };
export const valueCardStyles = { backgroundColor: 'white', padding: '2rem', borderRadius: '15px', textAlign: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' };
export const valueIconStyles = { fontSize: '3rem', marginBottom: '1rem' };
export const valuesTitleStyles = { fontSize: '1.3rem', fontWeight: '700', marginBottom: '1rem', color: '#333' };
export const valueDescStyles = { color: '#666', lineHeight: '1.6' };



export const teamGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' };
export const teamCardStyles = { backgroundColor: 'white', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', textAlign: 'center' };
export const teamImageStyles = { width: '100%', height: '250px', objectFit: 'cover' };
export const teamContentStyles = { padding: '2rem' };
export const teamNameStyles = { fontSize: '1.3rem', fontWeight: '700', marginBottom: '0.5rem', color: '#333' };
export const teamPositionStyles = { color: '#006C35', fontWeight: '600', marginBottom: '1rem' };
export const teamBioStyles = { color: '#666', lineHeight: '1.6' };

export const timelineStyles = { display: 'flex', flexDirection: 'column', gap: '2rem', maxWidth: '800px', margin: '0 auto' };
export const timelineItemStyles = { display: 'flex', gap: '2rem', alignItems: 'flex-start' };
export  const timelineYearStyles = { backgroundColor: '#006C35', color: 'white', padding: '0.5rem 1rem', borderRadius: '20px', fontWeight: '700', minWidth: '80px', textAlign: 'center' };
export const timelineContentStyles = { flex: 1 };
export const timelineEventStyles = { fontSize: '1.3rem', fontWeight: '700', marginBottom: '0.5rem', color: '#333' };
export const timelineDescStyles = { color: '#666', lineHeight: '1.6' };

export const servicesGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2rem' };
export const serviceCardStyles = { backgroundColor: 'white', padding: '2rem', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' };
export const serviceIconStyles = { fontSize: '3rem', marginBottom: '1rem' };
export const serviceTitleStyles = { fontSize: '1.4rem', fontWeight: '700', marginBottom: '1rem', color: '#333' };
export const serviceDescStyles = { color: '#666', lineHeight: '1.6', marginBottom: '1.5rem' };
export const serviceFeaturesStyles = { listStyle: 'none', padding: 0 };
export const serviceFeatureStyles = { padding: '0.5rem 0', color: '#666', borderBottom: '1px solid #f0f0f0' };



export const membershipTitleStyles = {
    fontSize: '1.5rem',
    fontWeight: '700',
    marginBottom: '1rem',
    color: '#333'
  };

  export const membershipContentStyles = {
    padding: '2rem'
  };

  export   const membershipPeriodStyles = {
    fontSize: '1rem',
    color: '#666'
  };

  export  const premiumCardStyles = {
    border: '3px solid #006C35',
    transform: 'scale(1.05)'
  };

  export  const membershipBadgeStyles = {
    position: 'absolute',
    top: '20px',
    right: '-30px',
    backgroundColor: '#C41E3A',
    color: 'white',
    padding: '0.5rem 2rem',
    fontSize: '0.9rem',
    fontWeight: '600',
    transform: 'rotate(45deg)',
    width: '150px',
    textAlign: 'center'
  };


export const membershipGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' };
export const membershipCardStyles = { backgroundColor: 'white', padding: '2rem', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', position: 'relative' };
export const popularCardStyles = { border: '2px solid #006C35', transform: 'scale(1.05)' };
export const popularBadgeStyles = { position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#006C35', color: 'white', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.9rem', fontWeight: '600' };
export const membershipHeaderStyles = { textAlign: 'center', marginBottom: '2rem' };
export const membershipNameStyles = { fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem', color: '#333' };
export const membershipPriceStyles = { marginBottom: '1rem' };
export const priceNumberStyles = { fontSize: '2.5rem', fontWeight: '700', color: '#006C35' };
export const priceDurationStyles = { color: '#666', fontSize: '1rem' };
export const membershipFeaturesStyles = { listStyle: 'none', padding: 0 };
export const membershipFeatureStyles = { padding: '0.5rem 0', color: '#666' };
export const imageStyles = { width: '100%', height: '400px', objectFit: 'cover', borderRadius: '10px' };

export const processGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' };
export const processStepStyles = { textAlign: 'center' };
export const processNumberStyles = { width: '60px', height: '60px', backgroundColor: '#006C35', color: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', fontWeight: '700', margin: '0 auto 1rem auto' };
export const processStepTitleStyles = { fontSize: '1.3rem', fontWeight: '700', marginBottom: '1rem', color: '#333' };
export const processStepDescStyles = { color: '#666', lineHeight: '1.6' };

export const ctaSectionStyles = { textAlign: 'center' };
export const centerDescStyles = { fontSize: '1.1rem', lineHeight: '1.7', maxWidth: '600px', margin: '0 auto 2rem auto', textAlign: 'center' };
export const ctaButtonsStyles = { display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' };
export const valueTitleStyles = { fontSize: '1.3rem', fontWeight: '700', marginBottom: '1rem', color: '#333' };

export const statsGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', textAlign: 'center' };
export const statItemStyles = { backgroundColor: 'white', padding: '2rem', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' };
export const statNumberStyles = { fontSize: '2.5rem', fontWeight: '700', color: '#006C35', marginBottom: '0.5rem' };
export const statLabelStyles = { color: '#666', fontSize: '1.1rem' };

export const footerStyles = { backgroundColor: '#2c3e50', color: 'white', padding: '3rem 0' };
export const footerGridStyles = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' };
export const footerTitleStyles = { marginBottom: '1rem' };
export const footerDescStyles = { marginBottom: '1.5rem', lineHeight: '1.6' };
export const footerSectionTitleStyles = { marginBottom: '1rem' };
export const footerLinksStyles = { listStyle: 'none', padding: 0 };
export const footerLinkItemStyles = { marginBottom: '0.5rem' };
export const footerLinkStyles = { color: 'white', textDecoration: 'none', transition: 'color 0.3s ease' };
export const contactInfoStyles = {};
export const contactItemStyles = { marginBottom: '0.5rem' };
export const socialMediaStyles = { display: 'flex', gap: '1rem', flexWrap: 'wrap' };
export const socialLinkStyles = { display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'white', textDecoration: 'none', padding: '0.5rem 1rem', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '25px', transition: 'all 0.3s ease' };
export const socialIconStyles = { fontSize: '1.2rem' };
export const socialNameStyles = { fontSize: '0.9rem' };
export const footerBottomStyles = { textAlign: 'center', marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid #34495e' };
export const copyrightStyles = { margin: 0 };


export const socialIconImageStyles = { 
  width: '20px', 
  height: '20px', 
  objectFit: 'contain',
  filter: 'brightness(0) invert(1)' // Makes icons white to match footer text
};


export const eventModal = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '2rem'
}

export const eventModalTitle = {
    background: 'white',
    borderRadius: '20px',
    padding: '2.5rem',
    maxWidth: '500px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    position: 'relative'
}

export const eventModalButton = {
      position: 'absolute',
    top: '1rem',
    right: '1rem',
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    color: '#999',
    width: '2rem',
    height: '2rem',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

export const eventLabel = {
    fontSize: '1.8rem', 
    fontWeight: '700', 
    color: '#333', 
    margin: '0 0 0.5rem 0'
};

export const eventText = {
  color: '#666', fontSize: '1rem', margin: 0
};


export const eventModalDetails = {
      background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
    borderRadius: '12px',
    padding: '1.5rem',
    marginBottom: '2rem',
    border: '2px solid #006C35'
};

export const eventTitle = { margin: '0 0 0.5rem 0', color: '#333', fontSize: '1.2rem' };
export const eventDate = { margin: 0, color: '#666', fontSize: '0.95rem' };
export const eventLocation = { margin: '0.5rem 0 0 0', color: '#666', fontSize: '0.95rem' };


export const eventEmail = {
      display: 'block', 
      fontSize: '1rem', 
      fontWeight: '600', 
      color: '#333', 
      marginBottom: '0.5rem'
};

export const eventEmailInput = {
      padding: '0.9rem',
      fontSize: '1rem',
      border: '2px solid #e1e1e1',
      borderRadius: '10px',
      width: '100%',
      boxSizing: 'border-box',
      transition: 'border-color 0.2s ease'
};

export const eventCancel = {
                    background: 'transparent',
                  color: '#666',
                  border: '2px solid #ccc',
                  padding: '0.9rem 1.8rem',
                  borderRadius: '10px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
};


export const eventPaymentLabel = {
  display: 'block', 
  marginBottom: '0.5rem', 
  fontWeight: '600' 
};

export const eventCard = {
      padding: '0.8rem',
    border: '2px solid #e1e1e1',
    borderRadius: '10px'
}

export const eventLearnMoreButton = {
        background: 'transparent',
      color: '#006C35',
      border: '2px solid #006C35',
      padding: '1rem 2rem',
      borderRadius: '12px',
      fontSize: '1.1rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
}

export const eventRegisterButton = {
      background: 'linear-gradient(135deg, #006C35, #00a84f)',
      color: 'white',
      border: 'none',
      padding: '1rem 2rem',
      borderRadius: '12px',
      fontSize: '1.1rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(0,108,53,0.3)'
};

export const eventDetail = {
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
      gap: '1rem', 
      marginBottom: '1.5rem',
      padding: '1.5rem',
      background: '#f8f9fa',
      borderRadius: '12px'
};


export const eventDetailPrice = {
                        background: 'linear-gradient(135deg, #006C35, #00a84f)',
                        color: 'white',
                        padding: '0.5rem 1rem',
                        borderRadius: '25px',
                        fontSize: '0.9rem',
                        fontWeight: '600'
};

export const eventDiv = {
                  background: 'white',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
                  display: 'grid',
                  gridTemplateColumns: '400px 1fr',
                  gap: '0',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
};

export const eventLocationColorVeryDarkGrey = { color: '#333' };
export const eventLocationColorDarkGrey = { color: '#555' };

export const eventHeader = {
      background: 'linear-gradient(135deg, #006C35 0%, #00a84f 100%)',
      color: 'white',
      padding: '4rem 0',
      textAlign: 'center'
};


export const eventPayment = {
      color: 'white',
      border: 'none',
      padding: '0.9rem 1.8rem',
      borderRadius: '10px',
      fontSize: '1rem',
      fontWeight: '600',
      transition: 'all 0.2s ease',
};

export const membershipModal = {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
};

export const membershipContainer = {
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '15px',
        width: '90%',
        maxWidth: '500px'
};

export const membershipButton = {
      marginTop: '1rem',
      width: '100%'
};


export const eventstyles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px'
  },
  tabContainer: {
    display: 'flex',
    borderBottom: '2px solid #e0e0e0',
    marginBottom: '2rem'
  },
  tabButton: {
    background: 'none',
    border: 'none',
    padding: '12px 20px',
    cursor: 'pointer',
    borderBottom: '3px solid transparent',
    fontSize: '16px',
    fontWeight: '500',
    color: '#666',
    transition: 'all 0.3s ease'
  },
  activeTab: {
    color: '#007bff',
    borderBottomColor: '#007bff'
  },
  tabCount: {
    backgroundColor: '#007bff',
    color: 'white',
    borderRadius: '12px',
    padding: '2px 6px',
    fontSize: '12px',
    marginLeft: '6px'
  },
  tabContent: {
    animation: 'fadeIn 0.3s ease'
  },
  sectionTitle: {
    fontSize: '1.5rem',
    marginBottom: '1rem',
    color: '#333'
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1.5rem'
  },
  formGroup: {
    marginBottom: '1rem' ,
    padding: '2px'
  },
  formLabel: {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: '500',
    color: '#333'
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    color: '#333'
  },
  formInput: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px'
  },
  formTextarea: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    resize: 'vertical'
  },
  checkbox: {
    margin: '0'
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1rem',
    padding: '1px',
  },
  imagePreview: {
    marginTop: '10px'
  },
  previewImage: {
    maxWidth: '200px',
    maxHeight: '120px',
    objectFit: 'cover',
    borderRadius: '4px',
    border: '1px solid #ddd'
  },
  addButton: {
    background: '#28a745',
    color: 'white',
    border: 'none',
    padding: '10px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500'
  },
  emptyState: {
    textAlign: 'center',
    padding: '2rem',
    color: '#666',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    border: '2px dashed #ddd'
  },
  speakersList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  speakerCard: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '1.5rem',
    backgroundColor: '#f9f9f9'
  },
  agendaList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  agendaCard: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '1.5rem',
    backgroundColor: '#f9f9f9'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem'
  },
  cardTitle: {
    margin: '0',
    color: '#333',
    fontSize: '1.1rem'
  },
  deleteButton: {
    background: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '6px 10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  speakerImagePreview: {
    marginTop: '10px'
  },
  speakerImage: {
    width: '80px',
    height: '80px',
    objectFit: 'cover',
    borderRadius: '50%',
    border: '2px solid #ddd'
  },
  agendaOrder: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  orderNumber: {
    backgroundColor: '#007bff',
    color: 'white',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold'
  },
  moveButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  },
  moveButton: {
    background: '#6c757d',
    color: 'white',
    border: 'none',
    padding: '2px 6px',
    borderRadius: '3px',
    cursor: 'pointer',
    fontSize: '10px'
  },
  actionButtons: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
    marginTop: '2rem',
    paddingTop: '2rem',
    borderTop: '1px solid #e0e0e0'
  },
  secondaryButton: {
    background: '#6c757d',
    color: 'white',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  primaryButton: {
    background: '#007bff',
    color: 'white',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500'
  }
};

  export const notificationContainerStyles = {
    position: 'fixed',
    top: '100px',
    // right: '20px',
    left: '20px',
    zIndex: 10000,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    maxWidth: '400px'
  };

  export const notificationStyles = {
    background: '#4caf50',
    color: 'white',
    padding: '16px 20px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    transform: 'translateX(100%)',
    animation: 'slideIn 0.3s ease-out forwards',
    minWidth: '300px'
  };

  export const notificationErrorStyles = {
    background: '#f44336'
  };

  export const notificationWarningStyles = {
    background: '#ff9800'
  };

  export const notificationContentStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  };

  export const notificationIconStyles = {
    fontSize: '18px'
  };

  export const notificationMessageStyles = {
    flex: 1,
    fontSize: '14px',
    lineHeight: '1.4'
  };

  export const notificationCloseStyles = {
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    padding: '0',
    marginLeft: '10px',
    opacity: 0.8
  };